/* DO NOT EDIT THIS FILE BY HAND!
 * This file is auto-generated by a script, generate-market-colors.ts.
 * To re-generate this file, run the following in the kyoko directory
 *
 * $> yarn generate
 */
// spell-checker: disable
import type { DefaultTheme } from 'styled-components';

const MARKET_COLORS = {
  'MjRleGNoYW5nZQ==': '#00ABD0', // 24exchange
  'YWxhbWVkYQ==': '#00ABD0', // alameda
  'YXF1YW5vdw==': '#52A2B1', // aquanow
  'YjJjMg==': '#601865', // b2c2
  'YmNiZ3JvdXA=': '#105FF5', // bcbgroup
  'YmluYW5jZQ==': '#CCAA3E', // binance
  YmluYW5jZV9mdXR1cmVz: '#CCAA3E', // binance_futures
  'Yml0ZmluZXg=': '#01A781', // bitfinex
  Yml0bWV4: '#0645E5', // bitmex
  'Yml0c3RhbXA=': '#159E49', // bitstamp
  'Y29pbmJhc2U=': '#0052FF', // coinbase
  Y29wcGVy: '#67E6D0', // copper
  'Y3VtYmVybGFuZA==': '#8C8778', // cumberland
  'ZGVyaWJpdA==': '#00CFBE', // deribit
  'ZHZjaGFpbg==': '#204FFF', // dvchain
  ZW5pZ21h: '#F1783F', // enigma
  'ZXJpc3g=': '#00EBB9', // erisx
  'ZmlyZWJsb2Nrcw==': '#F76500', // fireblocks
  'Zmxvd3RyYWRlcnM=': '#E1272C', // flowtraders
  ZnR4: '#03B2CB', // ftx
  Z2FsYXh5: '#B1B1B1', // galaxy
  Z2VtaW5p: '#29CFE8', // gemini
  'Z2VuZXNpcw==': '#103FFB', // genesis
  'aGVobWV5ZXI=': '#50B29A', // hehmeyer
  'aHVvYmk=': '#12B298', // huobi
  'amFuZXN0cmVldA==': '#4C87E3', // janestreet
  'anVtcA==': '#1CE7C2', // jump
  a3Jha2Vu: '#5D45DC', // kraken
  a3Vjb2lu: '#23AF91', // kucoin
  'bG1heGRpZ2l0YWw=': '#C4B37F', // lmaxdigital
  'bnlkaWc=': '#0CBDA8', // nydig
  b2tjb2lu: '#F74D99', // okcoin
  b2t4: '#DFEA52', // okx
  'b2tleA==': '#DFEA52', // okex
  b3Ns: '#35525E', // osl
  'cG9sb25pZXg=': '#3BEFD1', // poloniex
  c2ln: '#002953', // sig
  'c2lsdmVyZ2F0ZQ==': '#92B7BC', // silvergate
  c3VjZGVu: '#005DA9', // sucden
  dW5pc3dhcF90cmFkaW5n: '#FF007A', // uniswap_trading
  'dmlydHU=': '#00CC99', // virtu
  'd2ludGVybXV0ZQ==': '#A0E32D', // wintermute
};
export const getMarketColor = (market: string, theme: DefaultTheme): string =>
  MARKET_COLORS[btoa(market) as keyof typeof MARKET_COLORS] ?? theme.colors.blue.lighten;
